import { SVGProps } from "react";

const ToastErrorIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" width="32" height="32" rx="16" fill="#EF476F" fillOpacity="0.08" />
      <path
        d="M20.5 20L16.5 16M16.5 16L12.5 12M16.5 16L20.5 12M16.5 16L12.5 20"
        stroke="#EF476F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ToastErrorIcon;
